<template>
  <div id="MyWithdraw">
    <div class="headerContent">
      <div class="contentWrap1">
        <p>
          可出金额：<span>{{ myAccount.canOutMoney | toThousands }}</span>
        </p>
        <!-- <p>
          上日权益：<span>{{ myAccount.lastRight | toThousands }}</span>
        </p> -->
      </div>
    </div>
    <div class="centerContent">
      <div class="leftContent">
        <div class="topTitle">入金</div>
        <div class="textWrap">
          <p class="tip">
            <i class="el-icon-warning"></i>&nbsp;温馨提示:
            入金时间为&nbsp;&nbsp;
            <span>24小时(清算时间除外)</span>
          </p>
          <div class="bankDetails">
            <div class="bankDetailsWrap">
              <!-- <div class="desc">
                <p class="title">平台收款银行</p>
                <p class="text1">{{ bankDetails.bankAccount }}</p>
                <p
                  v-clipboard:copy="bankDetails.bankAccount"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  aria-hidden="true"
                  class="iconCopy"
                >复制</p>
              </div> -->
              <div class="desc desc1">
                <p class="title">平台收款方账号</p>
                <p class="text1">{{ bankDetails.bankAccountName }}</p>
                <p
                  v-clipboard:copy="bankDetails.bankAccountName"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  aria-hidden="true"
                  class="iconCopy"
                >复制</p>
              </div>
              <div class="desc desc1">
                <p class="title">平台收款账号</p>
                <p class="text1">{{ bankDetails.bankAccountNumber }}</p>
                <p
                  v-clipboard:copy="bankDetails.bankAccountNumber"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  aria-hidden="true"
                  class="iconCopy"
                >复制</p>
              </div>
              <div class="desc desc1">
                <p class="title"> 开户行联行号</p>
                <p class="text1">{{ bankDetails.openBankNumber }}</p>
                <p
                  v-clipboard:copy="bankDetails.openBankNumber"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  aria-hidden="true"
                  class="iconCopy"
                >复制</p>
              </div>
              <div class="desc desc1">
                <p class="title">开户支行地址</p>
                <p class="text1">{{ bankDetails.bankAccountAddress }}</p>
                <p
                  v-clipboard:copy="bankDetails.bankAccountAddress"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  aria-hidden="true"
                  class="iconCopy"
                >复制</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightContent">
        <div class="topTitle">出金</div>
        <div class="textWrap">
          <p class="tip">
            <i class="el-icon-warning"></i>&nbsp;温馨提示:
            出金时间为&nbsp;&nbsp; <span>24小时(清算时间{{ time }}除外)</span>
          </p>
          <div class="bankDetails">
            <div class="bankDetailsWrap">
              <p class="desc desc1">
                <span class="title">出金金额</span>
                <el-input
                  v-model="ruleForm.amount"
                  :placeholder="'可出金额   ' + myAccount.canOutMoney"
                >
                  <template slot="suffix">
                    <span class="iconCopy" style="color:rgba(255,255,255,0.6)" @click="getAllMoney">全部</span>
                  </template>
                </el-input>
              </p>
              <p v-if="!showFee" class="desc desc1" style="border-bottom: none"></p>
              <p v-if="showFee" class="desc desc1">
                <span class="title">茶资产抵扣手续费</span>
                <el-select
                  v-model="ruleForm.jf"
                  class="searchSelect"
                  size="small"
                  placeholder="请选择茶资产"
                >
                  <el-option
                    v-for="item in jfList"
                    :key="item.symbolId"
                    :label="item.symbolNameCh + item.symbolNameEn"
                    :value="item.symbolId"
                  >
                  </el-option>
                </el-select>
              </p>
              <p class="desc desc1">
                <span class="title">资金密码</span>
                <el-input
                  v-model="ruleForm.password"
                  :type="passType"
                  auto-complete="new-password"
                  placeholder="请输入密码"
                >
                  <template slot="suffix">
                    <img
                      class="eyeStyle"
                      :src="passwordIcon"
                      alt=""
                      @click="changeType"
                    >
                  </template>
                </el-input>
              </p>
            </div>
          </div>
          <div class="btnWrap">
            <div class="feeStyle"> {{ showFee ? '出金手续费：' + fee : '' }}</div>
            <el-button
              :loading="loading"
              :disabled="btnDisenable"
              type="primary"
              @click="handleSubmit"
            ><span style="color:#fff">提交</span></el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 出入金流水 -->
    <div class="flow">
      <div class="headerWrap">
        <div class="leftText">出入金流水</div>
        <!-- <div class="rightText">
          <div class="selectText">类型</div>
          <el-select v-model="typeCode" placeholder="请选择">
            <el-option label="全部" value="102" />
            <el-option label="出金" value="101" />
            <el-option label="入金" value="101" />
            <el-option label="出金错误回滚资金" value="101" />
          </el-select>
          <el-date-picker
            v-model="selectData"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="margin:3px 13px 0 13px"
            value-format="yyyyMMdd"
          />
          <el-button
            type="danger"
            @click="param_queryMyIntegralDetail"
          >查询</el-button>
          <el-button type="success" @click="resetData">重置</el-button>
        </div> -->
      </div>
      <div v-if="tableData.length == 0" class="tableWrap">
        <div class="no-datas1">
          <div
            class="no-data-img"
            style="margin: 50px auto 20px; width: 100px;"
          >
            <img
              src="../../../assets/images/no_data.png"
              alt=""
              style="width: 100%;"
            >
            <div style="text-align:center">暂无数据</div>
          </div>
        </div>
      </div>
      <div v-else class="tableWrap">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column align="center" prop="bizName" label="类型">
          </el-table-column>
          <el-table-column align="center" prop="amount" label="发生额">
          </el-table-column>
          <el-table-column prop="occurTime" label="时间">
            <template slot-scope="scope">
              {{ scope.row.occurTime | dateFormate }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="flowId" label="市场流水号">
          </el-table-column>
          <el-table-column align="center" prop="bankFlowId" label="银行流水号">
          </el-table-column>
        </el-table>
        <el-pagination
          popper-class="_popStyle"
          :current-page="pageData.currentPage"
          :page-sizes="pageData.pageSizes"
          :page-size="pageData.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="pageData.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
/*global http protocol*/
import { mapGetters } from 'vuex'
import md5 from 'js-md5'
export default {
  data() {
    return {
      time: window.g.AMOUNT_TIME,
      showFee: false,
      jfList: [],
      loading: false,
      bankId: null,
      passType: 'password',
      passwordIcon: '',
      openImg: require('../../../assets/images/icon/openeye.png'),
      closeImg: require('../../../assets/images/icon/closeeye.png'),
      selectData: '',
      typeCode: null,
      tableData: [],
      pageData: {
        total: 0,
        pageSizes: [5, 10, 20],
        pageSize: 10,
        currentPage: 1
      },
      bankDetails: {
        bankAccount: '平安银行',
        bankAccountName: ' 贵州登记结算有限责任公司',
        bankAccountNumber: '020790001400104779',
        // openBankName: '平安银行济南高新支行',
        openBankNumber: '3074910069707',
        // signFlag: null,
        bankAccountAddress: '贵州银行股份有限公司湄潭县遵义红路支行'
      },
      typeFlag: 'text',
      isWithdraw: false,
      /** 银行 */
      banks: [],
      /** 银行 end */
      ruleForm: {
        bankId: '',
        amount: '',
        password: '',
        jf: null
      },
      btnDisenable: false,
      myAccount: {
        accountId: 0,
        avilibleMargin: 0,
        balance: 0,
        createTime: 0,
        currency: '人民币',
        enName: 'CNY',
        firmId: 0,
        frozenFunds: 0,
        lastBalance: 0,
        marketId: 32,
        marketName: '现货买进',
        marketType: '主市场',
        updateTime: 0
      },
      fee: 0,
      feeData: {}
    }
  },
  computed: {
    ...mapGetters([
      'sessionInfoGetter',
      'h_accountTime',
      'myassetDataGetter',
      'h_sumClosePl',
      'marketStatusGetter'
    ])
  },
  watch: {
    'ruleForm.amount'() {
      // 收费类型0：比例1：固定值
      if (this.feeData.feeType === 1) {
        this.fee = this.feeData.feeRate
      } else if (this.feeData.feeType === 0) {
        const feee = Number(this.feeData.feeRate * this.ruleForm.amount).toFixed(2)
        this.fee = feee >= 0.01 ? feee : 0.01
      }
    }
  },

  mounted() {
    // this.bankInfo()
    this.getMyAccount()
    this.param_queryMyIntegralDetail()
    this.queryFeeType() // 茶资产列表查询
    this.passwordIcon = this.closeImg
  },
  methods: {
    // 出金页面茶资产列表查询
    queryFeeType() {
      http.postFront(protocol.param_queryFeeType).then(response => {
        // const that = this
        const { code, message, value } = response.data
        if (Number(code) === 0) {
          value.symbolList.forEach(element => {
            this.jfList.push(element)
          })
          // 收费类型0：比例1：固定值
          this.feeData = value
          if (this.feeData.feeType === 1) {
            this.fee = this.feeData.feeRate
          }
          if (this.feeData.feeRate > 0) {
            this.ruleForm.jf = this.jfList?.[0].symbolId
            this.showFee = true
          } else {
            this.showFee = false
          }
        } else {
          this.$message(message)
        }
      })
    },
    // 查询开户信息 --- 获取签约信息
    bankInfo() {
      http.postFront(protocol.param_findTrader).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (value) {
            this.bankId = value.bankId
          }
        } else {
          this.$message(message)
        }
      })
    },
    getAllMoney() {
      this.ruleForm.amount = this.myAccount.canOutMoney
    },
    changeType() {
      this.passType = this.passType == 'password' ? 'text' : 'password'
      this.passwordIcon =
        this.passType == 'password' ? this.closeImg : this.openImg
    },
    onCopy() {
      this.$message('复制成功')
    },
    onError() {
      this.$message('复制失败')
    },
    resetData() {
      this.selectData = ''
      this.typeCode = null
      this.tableData = []
      this.pageData = {
        total: 0,
        pageSizes: [5, 10, 20],
        pageSize: 10,
        currentPage: 1
      }
      this.param_queryMyIntegralDetail()
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.param_queryMyIntegralDetail()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.param_queryMyIntegralDetail()
    },
    // 查询出入金流水
    param_queryMyIntegralDetail() {
      protocol.param_queryFirmBankAccountInoutFundsFlowFront.param.bizCode = null
      protocol.param_queryFirmBankAccountInoutFundsFlowFront.param.page =
        this.pageData.currentPage - 1
      protocol.param_queryFirmBankAccountInoutFundsFlowFront.param.size = this.pageData.pageSize
      http
        .postFrontChange(
          protocol.param_queryFirmBankAccountInoutFundsFlowFront,
          0
        )
        .then(response => {
          const { code, value, message } = response.data
          if (Number(code) == '0') {
            this.pageData.total = value.totalElements
            const arr = value.content
            this.tableData = arr
          } else {
            this.$message(message)
          }
        })
    },
    // 得到可出金额和上日权益
    getMyAccount() {
      http.postFrontMarket0(protocol.param_mineAsset).then(response => {
        const { code, value, message } = response.data
        if (Number(code) == 0) {
          if (value) {
            this.myAccount = value
            if (this.myAccount.canOutMoney < 0) {
              this.myAccount.canOutMoney = 0
            }
          }
        } else {
          this.$message(message)
        }
      })
    },
    // 出金提交
    handleSubmit(name) {
      console.log(this.ruleForm.jf)
      const reg = /^\d{6}$/
      // 最多两位小数
      const regMoney = /^(([0-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/
      if (!this.ruleForm.amount) {
        this.$message('请输入出金金额')
        return false
      } else if (this.ruleForm.amount <= 0) {
        this.$message('请输入正确的出金金额')
        return false
      } else if (!regMoney.test(this.ruleForm.amount)) {
        this.$message('出金金额最多为两位小数')
        return false
      } else if (!this.ruleForm.password) {
        this.$message('请输入资金密码')
        return false
      } else if (!reg.test(this.ruleForm.password)) {
        this.$message('请输入正确的资金密码')
        return false
      }
      //  else if (!this.ruleForm.jf) {
      //   this.$message('请选择茶资产抵扣手续费')
      //   return false
      // }
      protocol.param_fundOutByMarket.param.transactionAmount = this.ruleForm.amount
      // protocol.param_fundOutByMarket.param.tranType = 1
      // protocol.param_fundOutByMarket.param.firmId = this.sessionInfoGetter.firmId
      protocol.param_fundOutByMarket.param.symbolId = this.ruleForm.jf ? this.ruleForm.jf : null
      protocol.param_fundOutByMarket.param.memo = md5(
        '47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + this.ruleForm.password
      )
      const that = this
      this.btnDisenable = true
      this.loading = true
      http
        .postFrontMarket0(protocol.param_fundOutByMarket)
        .then(response => {
          const { code, message } = response.data
          that.btnDisenable = false
          that.loading = false
          if (code === '0' || code === 0) {
            this.$message('提交成功')
            this.ruleForm.password = ''
            this.ruleForm.amount = null
            setTimeout(() => {
              that.getMyAccount()
              that.param_queryMyIntegralDetail()
            }, 1500)
          } else {
            this.$message(message)
          }
        })
        .catch(response => {
          that.btnDisenable = false
          that.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
#MyWithdraw {
  .el-button--primary{
    span{
      color: #fff !important;
    }
  }
  .el-pagination {
    padding: 50px 0 20px 0;
  }
  .headerContent {
    height: 68px;
    line-height: 68px;
    margin: 20px;
    background: linear-gradient(180deg, #1f243c 0%, #323855 100%);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
    .contentWrap1 {
      display: flex;
      justify-content: flex-end;
      p {
        padding-right: 20px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.5);
        span {
          font-size: 20px;
          font-weight: 600;
          color: #ffffff;
        }
      }
    }
  }
  .centerContent {
    display: flex;
    margin: 0 20px;
    margin-bottom: 20px;
    .textWrap {
      background-color: #262941;
    }
    .el-icon-warning {
      color: #ff4d4d;
    }
    .tip {
      height: 55px;
      line-height: 55px;
      font-size: 14px;
      text-align: center;
      color: #ff4d4d;
      background: linear-gradient(180deg, #1f243c 0%, #323855 100%);
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
      span {
        color: #ff3333;
      }
    }
    .desc {
      font-size: 18px;
      height: 71px;
      line-height: 70px;
      // width: 90%;
      margin: 0 40px;
      display: flex;
      justify-content: space-between;
      // margin: 0 98px;
      border-bottom: 1px solid rgba(216, 216, 216, 0.2);
      .title {
        width: 30%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.6);
      }
      .text1 {
        width: 60%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.9);
      }
      .iconCopy {
        width: 10%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: 500;
        color: #0486fe;
        cursor: pointer;
      }
    }
    .desc1{
      height: 89.5px;
      line-height: 89.5px;
    }
    .topTitle {
      font-size: 20px;
      padding-bottom: 20px;
      padding-left: 20px;
      font-weight: 500;
      color: #ffffff;
    }
    .rightContent {
      // .title {
      //   width: 25%;
      // }
      .el-input {
        width: 75%;
      }
      .el-select {
        width: 75%;
      }
      /deep/ .el-input__inner {
        background-color: #262941;
        border: none;
      }
    }
    .btnWrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // text-align: center;
      padding: 24px 0;
      .el-button {
        width: 108px;
        height: 40px;
        margin-right: 40px;
      }
    }
  }
  .centerContent > div {
    width: 50%;
  }
  .centerContent > div:first-child {
    margin-right: 20px;
  }
  .leftContent .bankDetailsWrap > div:last-child {
    border-bottom: none;
  }
  .feeStyle{
    margin-left:40px;
    font-size: 18px;
    font-family: PingFang HK-Medium, PingFang HK;
    font-weight: 500;
    color: #A8A9B3;
  }
  .flow {
    .headerWrap {
      display: flex;
      justify-content: space-between;
      height: 40px;
      line-height: 40px;
      padding: 0 20px;
      margin-bottom: 8px;
      background: linear-gradient(180deg, #1f243c 0%, #323855 100%);
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
      .leftText {
        font-size: 20px;
        font-weight: 500;
        color: #ffffff;
      }
      .rightText {
        display: flex;
        font-size: 16px;
        color: rgba(255, 255, 255, 0.6);
        .selectText {
          padding-right: 10px;
        }
        /deep/ .el-input__inner {
          height: 34px;
          line-height: 34px;
          background: linear-gradient(180deg, #1f243c 0%, #323855 100%);
          border: 1px solid rgba(220, 223, 230, 0.3);
        }
        /deep/ .el-date-editor .el-range-input {
          background: linear-gradient(180deg, #1f243c 0%, #323855 100%);
        }
        .el-button {
          padding: 7px 25px;
        }
      }
    }
  }
  .eyeStyle {
    width: 22px;
    cursor: pointer;
    vertical-align: middle;
  }
  /deep/ .el-input__inner {
    color: rgba(255, 255, 255, 0.9);
  }
}
</style>
